var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFreeWifi = function SvgFreeWifi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "CurrentColor",
    d: "M7.003 7a1.667 1.667 0 1 0 0 3.333 1.667 1.667 0 0 0 0-3.333Zm0 2.667a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "CurrentColor",
    d: "M7.001 5a3.675 3.675 0 0 0-3.537 2.698.333.333 0 0 0 .643.176 3 3 0 0 1 5.788 0 .334.334 0 0 0 .644-.176A3.674 3.674 0 0 0 7 5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "CurrentColor",
    d: "M7 2.333a5.634 5.634 0 0 0-5.088 3.17.333.333 0 1 0 .599.295 5 5 0 0 1 8.975-.01.335.335 0 0 0 .6-.296A5.634 5.634 0 0 0 7 2.333Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "CurrentColor",
    d: "M13.766 3.728A8 8 0 0 0 .26 3.693a.333.333 0 0 0 .56.36 7.333 7.333 0 0 1 12.383.031.334.334 0 0 0 .563-.356Z"
  })));
};
export default SvgFreeWifi;